import API from "./api";

const EtiquetteService = {
  getAll: async () => {
    const response = await API.get("/etiquettes");
    return response.data.donnees;
  },

  getById: async (id: number) => {
    const response = await API.get(`/etiquettes/${id}`);
    return response.data.donnees;
  },

  create: async (payload: any) => {
    const response = await API.post("/etiquettes", payload);
    return response.data.donnees;
  },

  update: async (id: number, payload: any) => {
    const response = await API.put(`/etiquettes/${id}`, payload);
    return response.data.donnees;
  },

  delete: async (id: number) => {
    const response = await API.delete(`/etiquettes/${id}`);
    return response.data.donnees;
  },
};

export default EtiquetteService;
